import React from 'react';
import styled from 'styled-components';
import { makeExternalUrl, attachLocale, attachCategorySlug } from '../../../../lib/utils';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';
import ChevronLeft from '../../../svgs/ChevronLeft';
import ChevronRight from '../../../svgs/ChevronRight';
import { getBrowseCategoriesAnalytics } from '../NavigationCategoriesBar/browseCategoriesAnalytics';
import {
  LightLinkAnchor,
  BoldTitleSpan,
  ImgAlignLeftSpan,
  FlexSpaceBetweenDiv,
  FlexCenterDiv,
  CategoryIconImg,
  CategoryTitleSpan,
  ImgAlignTopSpan,
  ImgAlignRightSpan,
  BackButtonTitleSpan,
  MenuItemContainer,
  BorderedMenuItemContainer,
  BorderedMenuItemContainerTop,
  LightButton,
  LightBackButton,
} from './MobileMenuStyles';

const BottomMenuSectionLinkContainerDiv = styled.div`
  padding-top: ${p => p.theme.unit(2)};
  padding-bottom: ${p => p.theme.unit(1)};
`;

const BACK_TO_MAIN_MENU_ANALYTICS_SLUG = 'back-to-main-menu';

const MobileMenuViewTwo = (props) => {
  const {
    locale,
    backButtonOnClick,
    primaryCategoryOnClick,
    browseCategoriesNavSlot,
    linkOneUrl,
    linkOneText,
    linkOneAnalyticsSlug,
    linkTwoUrl,
    linkTwoText,
    linkTwoAnalyticsSlug,
    parentCategorySlug,
    setFocusButton,
    globalPageConfig,
    theme,
  } = props;

  const backButtonText = globalPageConfig.backButtonText;

  const rootCategory = browseCategoriesNavSlot.rootCategory;

  const categoriesLink = rootCategory.subCategories.map((cat) => {
    const {
      subCategories,
      shops,
      slug,
      analyticsSlug,
      name,
      featureShops,
    } = cat;

    const resolvedIconUrl = makeExternalUrl(cat.categoryIconUrl);
    const shopsToFeature = featureShops && featureShops.length ? featureShops : shops;

    // When there are zero subcategories, then open the category page
    if (!subCategories || subCategories.length === 0) {
      let resolvedCategorySlug = attachCategorySlug(slug);
      resolvedCategorySlug = attachLocale(resolvedCategorySlug, locale);
      const track = getBrowseCategoriesAnalytics({
        analyticsSlug,
        url: resolvedCategorySlug,
      });

      return (
        <BorderedMenuItemContainer>
          <LightLinkAnchor
            href={track.url}
            id={track.dataTrackingId}
            data-track-id={track.dataTrackingId}
            data-track-click={track.dataTrack}
            data-track-type={DATA_TRACK_TYPE_INTERNAL}>
            <FlexSpaceBetweenDiv>
              <FlexCenterDiv>
                <CategoryIconImg src={resolvedIconUrl} alt="" aria-hidden="true"/>
                <CategoryTitleSpan>{cat.name}</CategoryTitleSpan>
              </FlexCenterDiv>
            </FlexSpaceBetweenDiv>
          </LightLinkAnchor>
        </BorderedMenuItemContainer>
      );
    }

    const track = getBrowseCategoriesAnalytics({ analyticsSlug });

    return (
      <BorderedMenuItemContainer>
        <LightButton
          onClick={(event) => primaryCategoryOnClick(
            event.target,
            subCategories,
            shopsToFeature,
            slug,
            analyticsSlug,
            name
          )}
          aria-haspopup="true"
          aria-expanded={slug === parentCategorySlug}
          id={track.dataTrackingId}
          data-track-id={track.dataTrackingId}
          data-track-click={track.dataTrack}
          data-track-type={DATA_TRACK_TYPE_INTERNAL}>
          <FlexSpaceBetweenDiv>
            <FlexCenterDiv>
              <CategoryIconImg src={resolvedIconUrl} alt="" aria-hidden="true"/>
              <CategoryTitleSpan>{cat.name}</CategoryTitleSpan>
            </FlexCenterDiv>
            <ImgAlignTopSpan>
              <ImgAlignRightSpan>
                <ChevronRight fill={theme.c.icon.interactive} />
              </ImgAlignRightSpan>
            </ImgAlignTopSpan>
          </FlexSpaceBetweenDiv>
        </LightButton>
      </BorderedMenuItemContainer>

    );
  });

  const backTrack = getBrowseCategoriesAnalytics({
    analyticsSlug: BACK_TO_MAIN_MENU_ANALYTICS_SLUG,
  });
  const backButton = (
    <BorderedMenuItemContainerTop>
      <LightBackButton
        onClick={backButtonOnClick}
        innerRef={element => element && setFocusButton(2, element.id, false)}
        id='mobile-back-2'
        data-track-id={backTrack.dataTrackingId}
        data-track-click={backTrack.dataTrack}
        data-track-type={DATA_TRACK_TYPE_INTERNAL}
      >
        <ImgAlignTopSpan>
          <ImgAlignLeftSpan>
            <ChevronLeft fill={theme.c.icon.interactive} />
          </ImgAlignLeftSpan>
        </ImgAlignTopSpan>
        <BackButtonTitleSpan>{backButtonText}</BackButtonTitleSpan>
      </LightBackButton>
    </BorderedMenuItemContainerTop>
  );

  // Build the two custom nav links from the CMS
  const bottomSectionLinks = [];
  if (linkOneUrl && linkOneText) {
    bottomSectionLinks.push({
      url: linkOneUrl,
      text: linkOneText,
      analyticsSlug: linkOneAnalyticsSlug,
    });
  }
  if (linkTwoUrl && linkTwoText) {
    bottomSectionLinks.push({
      url: linkTwoUrl,
      text: linkTwoText,
      analyticsSlug: linkTwoAnalyticsSlug,
    });
  }

  const bottomSectionLinkComponents = bottomSectionLinks.map((link) => {
    const resolvedLink = attachLocale(link.url, locale);
    const track = getBrowseCategoriesAnalytics({
      analyticsSlug: link.analyticsSlug,
      url: resolvedLink,
    });

    return (
      <MenuItemContainer>
        <LightLinkAnchor
          href={track.url}
          id={track.dataTrackingId}
          data-track-id={track.dataTrackingId}
          data-track-click={track.dataTrack}
          data-track-type={DATA_TRACK_TYPE_INTERNAL}>
          <BoldTitleSpan>{link.text}</BoldTitleSpan>
        </LightLinkAnchor>
      </MenuItemContainer>);
  });

  const bottomMenuSectionLinkContainer = (
    <BottomMenuSectionLinkContainerDiv>
      { bottomSectionLinkComponents }
    </BottomMenuSectionLinkContainerDiv>
  );

  return (
    <div>
      {backButton}
      {categoriesLink}
      {bottomMenuSectionLinkContainer}
    </div>
  );
};

export default MobileMenuViewTwo;
